import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronDown from '@/icons/SiChevronDown';
import SiChevronUp from '@/icons/SiChevronUp';
import { FC, PropsWithChildren, Suspense, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { SidebarLink } from './SidebarLink';

interface Props {
  title: string;
  collapsible?: boolean;
  to: string;
  sectionUrlIdentifier: string;
}

const isActiveSection = (currentUrl: string, sectionUrlIdentifier: string) => {
  const currentUrlSegments = currentUrl.split('/').filter(item => item);

  return currentUrlSegments.includes(sectionUrlIdentifier);
};

export const SidebarMainSection: FC<PropsWithChildren<Props>> = ({
  title,
  children,
  to,
  collapsible = false,
  sectionUrlIdentifier
}) => {
  const location = useLocation();
  const activeSection = isActiveSection(location.pathname, sectionUrlIdentifier);

  const [expanded, setExpanded] = useState(!collapsible || activeSection);

  useEffect(() => {
    setExpanded(!collapsible || activeSection);
  }, [activeSection, collapsible, setExpanded]);

  return (
    <div
      className="flex flex-col border-b p-3 pl-8 space-y-2"
      style={{ borderLeft: activeSection ? '8px solid #239cb6' : undefined }}
    >
      <div className="flex justify-between space-x-2" style={{ marginLeft: activeSection ? -5 : 0 }}>
        <SidebarLink to={to} name={title} className="text-gray-500 font-semibold" showOnPage={false} />
        {collapsible && (
          <div>
            <Button variant={ButtonVariant.Ghost} onClick={() => setExpanded(!expanded)}>
              {expanded ? <SiChevronUp className="text-xl" /> : <SiChevronDown className="text-xl" />}
            </Button>
          </div>
        )}
      </div>
      {expanded && (
        <Suspense>
          <div className="px-2 space-y-0.5">{children}</div>
        </Suspense>
      )}
    </div>
  );
};
